// Global
import DateFns from 'date-fns';

function initialDates(visitsOfWeek) {
  let weeks = visitsOfWeek.weeks;
  visitsOfWeek = {
    monday: '',
    tuesday: '',
    wednesday: '',
    thursday: '',
    friday: '',
    saturday: '',
    sunday: '',
    weeks: weeks,
    countWeek: ''
  };
  return visitsOfWeek;
}

export function generateMonth(visits) {
  let visitsOfWeek = {
    monday: '',
    tuesday: '',
    wednesday: '',
    thursday: '',
    friday: '',
    saturday: '',
    sunday: '',
    weeks: [],
    countWeek: ''
  };
  let countWeek = {
    planned: [],
    completed: [],
    notCompleted: []
  };
  // eslint-disable-next-line no-unused-vars
  for (let key in visits) {
    let visit = visits[key];
    let lastDayOfWeek = DateFns.endOfWeek(key, { weekStartsOn: 1 });
    let lastDayOfMonth = DateFns.endOfMonth(key);
    let visitPush = {
      planned: '',
      completed: '',
      notCompleted: ''
    };
    switch (DateFns.getDay(key)) {
      case 0:
        visitPush.date = key;
        if (visit.planned.length !== 0) {
          visitPush.planned = [...visit.planned];
          countWeek.planned.push(...visit.planned);
        }
        if (visit.completed.length !== 0) {
          visitPush.completed = [...visit.completed];
          countWeek.completed.push(...visit.completed);
        }
        if (visit.notCompleted.length !== 0) {
          visitPush.notCompleted = [...visit.notCompleted];
          countWeek.notCompleted.push(...visit.notCompleted);
        }
        visitsOfWeek.sunday = visitPush;
        if (
          DateFns.getDate(lastDayOfWeek) === DateFns.getDate(key) ||
          DateFns.getDate(lastDayOfMonth) === DateFns.getDate(key)
        ) {
          let week = {
            monday: visitsOfWeek.monday,
            tuesday: visitsOfWeek.tuesday,
            wednesday: visitsOfWeek.wednesday,
            thursday: visitsOfWeek.thursday,
            friday: visitsOfWeek.friday,
            saturday: visitsOfWeek.saturday,
            sunday: visitsOfWeek.sunday,
            countWeek: countWeek
          };
          visitsOfWeek.weeks.push(week);
          countWeek = { planned: [], completed: [], notCompleted: [] };
          visitsOfWeek = initialDates(visitsOfWeek);
        }
        break;
      case 1:
        visitPush.date = key;
        if (visit.planned.length !== 0) {
          visitPush.planned = [...visit.planned];
          countWeek.planned.push(...visit.planned);
        }
        if (visit.completed.length !== 0) {
          visitPush.completed = [...visit.completed];
          countWeek.completed.push(...visit.completed);
        }
        if (visit.notCompleted.length !== 0) {
          visitPush.notCompleted = [...visit.notCompleted];
          countWeek.notCompleted.push(...visit.notCompleted);
        }
        visitsOfWeek.monday = visitPush;
        if (
          DateFns.getDate(lastDayOfWeek) === DateFns.getDate(key) ||
          DateFns.getDate(lastDayOfMonth) === DateFns.getDate(key)
        ) {
          let week = {
            monday: visitsOfWeek.monday,
            tuesday: visitsOfWeek.tuesday,
            wednesday: visitsOfWeek.wednesday,
            thursday: visitsOfWeek.thursday,
            friday: visitsOfWeek.friday,
            saturday: visitsOfWeek.saturday,
            sunday: visitsOfWeek.sunday,
            countWeek: countWeek
          };
          visitsOfWeek.weeks.push(week);
          countWeek = { planned: [], completed: [], notCompleted: [] };
          visitsOfWeek = initialDates(visitsOfWeek);
        }
        break;
      case 2:
        visitPush.date = key;
        if (visit.planned.length !== 0) {
          visitPush.planned = [...visit.planned];
          countWeek.planned.push(...visit.planned);
        }
        if (visit.completed.length !== 0) {
          visitPush.completed = [...visit.completed];
          countWeek.completed.push(...visit.completed);
        }
        if (visit.notCompleted.length !== 0) {
          visitPush.notCompleted = [...visit.notCompleted];
          countWeek.notCompleted.push(...visit.notCompleted);
        }
        visitsOfWeek.tuesday = visitPush;
        if (
          DateFns.getDate(lastDayOfWeek) === DateFns.getDate(key) ||
          DateFns.getDate(lastDayOfMonth) === DateFns.getDate(key)
        ) {
          let week = {
            monday: visitsOfWeek.monday,
            tuesday: visitsOfWeek.tuesday,
            wednesday: visitsOfWeek.wednesday,
            thursday: visitsOfWeek.thursday,
            friday: visitsOfWeek.friday,
            saturday: visitsOfWeek.saturday,
            sunday: visitsOfWeek.sunday,
            countWeek: countWeek
          };
          visitsOfWeek.weeks.push(week);
          countWeek = { planned: [], completed: [], notCompleted: [] };
          visitsOfWeek = initialDates(visitsOfWeek);
        }
        break;
      case 3:
        visitPush.date = key;
        if (visit.planned.length !== 0) {
          visitPush.planned = [...visit.planned];
          countWeek.planned.push(...visit.planned);
        }
        if (visit.completed.length !== 0) {
          visitPush.completed = [...visit.completed];
          countWeek.completed.push(...visit.completed);
        }
        if (visit.notCompleted.length !== 0) {
          visitPush.notCompleted = [...visit.notCompleted];
          countWeek.notCompleted.push(...visit.notCompleted);
        }
        visitsOfWeek.wednesday = visitPush;
        if (
          DateFns.getDate(lastDayOfWeek) === DateFns.getDate(key) ||
          DateFns.getDate(lastDayOfMonth) === DateFns.getDate(key)
        ) {
          let week = {
            monday: visitsOfWeek.monday,
            tuesday: visitsOfWeek.tuesday,
            wednesday: visitsOfWeek.wednesday,
            thursday: visitsOfWeek.thursday,
            friday: visitsOfWeek.friday,
            saturday: visitsOfWeek.saturday,
            sunday: visitsOfWeek.sunday,
            countWeek: countWeek
          };
          visitsOfWeek.weeks.push(week);
          countWeek = { planned: [], completed: [], notCompleted: [] };
          visitsOfWeek = initialDates(visitsOfWeek);
        }
        break;
      case 4:
        visitPush.date = key;
        if (visit.planned.length !== 0) {
          visitPush.planned = [...visit.planned];
          countWeek.planned.push(...visit.planned);
        }
        if (visit.completed.length !== 0) {
          visitPush.completed = [...visit.completed];
          countWeek.completed.push(...visit.completed);
        }
        if (visit.notCompleted.length !== 0) {
          visitPush.notCompleted = [...visit.notCompleted];
          countWeek.notCompleted.push(...visit.notCompleted);
        }
        visitsOfWeek.thursday = visitPush;
        if (
          DateFns.getDate(lastDayOfWeek) === DateFns.getDate(key) ||
          DateFns.getDate(lastDayOfMonth) === DateFns.getDate(key)
        ) {
          let week = {
            monday: visitsOfWeek.monday,
            tuesday: visitsOfWeek.tuesday,
            wednesday: visitsOfWeek.wednesday,
            thursday: visitsOfWeek.thursday,
            friday: visitsOfWeek.friday,
            saturday: visitsOfWeek.saturday,
            sunday: visitsOfWeek.sunday,
            countWeek: countWeek
          };
          visitsOfWeek.weeks.push(week);
          countWeek = { planned: [], completed: [], notCompleted: [] };
          visitsOfWeek = initialDates(visitsOfWeek);
        }
        break;
      case 5:
        visitPush.date = key;
        if (visit.planned.length !== 0) {
          visitPush.planned = [...visit.planned];
          countWeek.planned.push(...visit.planned);
        }
        if (visit.completed.length !== 0) {
          visitPush.completed = [...visit.completed];
          countWeek.completed.push(...visit.completed);
        }
        if (visit.notCompleted.length !== 0) {
          visitPush.notCompleted = [...visit.notCompleted];
          countWeek.notCompleted.push(...visit.notCompleted);
        }
        visitsOfWeek.friday = visitPush;
        if (
          DateFns.getDate(lastDayOfWeek) === DateFns.getDate(key) ||
          DateFns.getDate(lastDayOfMonth) === DateFns.getDate(key)
        ) {
          let week = {
            monday: visitsOfWeek.monday,
            tuesday: visitsOfWeek.tuesday,
            wednesday: visitsOfWeek.wednesday,
            thursday: visitsOfWeek.thursday,
            friday: visitsOfWeek.friday,
            saturday: visitsOfWeek.saturday,
            sunday: visitsOfWeek.sunday,
            countWeek: countWeek
          };
          visitsOfWeek.weeks.push(week);
          countWeek = { planned: [], completed: [], notCompleted: [] };
          visitsOfWeek = initialDates(visitsOfWeek);
        }
        break;
      case 6:
        visitPush.date = key;
        if (visit.planned.length !== 0) {
          visitPush.planned = [...visit.planned];
          countWeek.planned.push(...visit.planned);
        }
        if (visit.completed.length !== 0) {
          visitPush.completed = [...visit.completed];
          countWeek.completed.push(...visit.completed);
        }
        if (visit.notCompleted.length !== 0) {
          visitPush.notCompleted = [...visit.notCompleted];
          countWeek.notCompleted.push(...visit.notCompleted);
        }
        visitsOfWeek.saturday = visitPush;
        if (
          DateFns.getDate(lastDayOfWeek) === DateFns.getDate(key) ||
          DateFns.getDate(lastDayOfMonth) === DateFns.getDate(key)
        ) {
          let week = {
            monday: visitsOfWeek.monday,
            tuesday: visitsOfWeek.tuesday,
            wednesday: visitsOfWeek.wednesday,
            thursday: visitsOfWeek.thursday,
            friday: visitsOfWeek.friday,
            saturday: visitsOfWeek.saturday,
            sunday: visitsOfWeek.sunday,
            countWeek: countWeek
          };
          visitsOfWeek.weeks.push(week);
          countWeek = { planned: [], completed: [], notCompleted: [] };
          visitsOfWeek = initialDates(visitsOfWeek);
        }
        break;
      default:
        break;
    }
  }
  return visitsOfWeek.weeks;
}

export function generateMonthProfessionals(monthNurse, monthDoctor) {
  const monthProfessionals = [];
  if (monthNurse.length > 0 && !(monthDoctor.length > 0)) {
    monthNurse.forEach(week => {
      let weekNurse = {
        monday: {
          nurse: week.monday
        },
        tuesday: {
          nurse: week.tuesday
        },
        wednesday: {
          nurse: week.wednesday
        },
        thursday: {
          nurse: week.thursday
        },
        friday: {
          nurse: week.friday
        },
        saturday: {
          nurse: week.saturday
        },
        sunday: {
          nurse: week.sunday
        },
        countWeek: {
          nurse: week.countWeek
        }
      };
      monthProfessionals.push(weekNurse);
    });
    return monthProfessionals;
  } else if (monthDoctor.length > 0 && !(monthNurse.length > 0)) {
    monthDoctor.forEach(week => {
      let weekDoctor = {
        monday: {
          doctor: week.monday
        },
        tuesday: {
          doctor: week.tuesday
        },
        wednesday: {
          doctor: week.wednesday
        },
        thursday: {
          doctor: week.thursday
        },
        friday: {
          doctor: week.friday
        },
        saturday: {
          doctor: week.saturday
        },
        sunday: {
          doctor: week.sunday
        },
        countWeek: {
          doctor: week.countWeek
        }
      };
      monthProfessionals.push(weekDoctor);
    });
    return monthProfessionals;
  }
  if (monthDoctor.length > 0 && monthNurse.length > 0) {
    monthNurse.forEach(week => {
      let weekNurse = {
        monday: {
          nurse: week.monday
        },
        tuesday: {
          nurse: week.tuesday
        },
        wednesday: {
          nurse: week.wednesday
        },
        thursday: {
          nurse: week.thursday
        },
        friday: {
          nurse: week.friday
        },
        saturday: {
          nurse: week.saturday
        },
        sunday: {
          nurse: week.sunday
        },
        countWeek: {
          nurse: week.countWeek
        }
      };
      monthProfessionals.push(weekNurse);
    });
    let count = 0;
    monthDoctor.forEach(week => {
      let weekProfessionals = {
        monday: {
          doctor: week.monday,
          nurse: monthProfessionals[count].monday.nurse
        },
        tuesday: {
          doctor: week.tuesday,
          nurse: monthProfessionals[count].tuesday.nurse
        },
        wednesday: {
          doctor: week.wednesday,
          nurse: monthProfessionals[count].wednesday.nurse
        },
        thursday: {
          doctor: week.thursday,
          nurse: monthProfessionals[count].thursday.nurse
        },
        friday: {
          doctor: week.friday,
          nurse: monthProfessionals[count].friday.nurse
        },
        saturday: {
          doctor: week.saturday,
          nurse: monthProfessionals[count].saturday.nurse
        },
        sunday: {
          doctor: week.sunday,
          nurse: monthProfessionals[count].sunday.nurse
        },
        countWeek: {
          doctor: week.countWeek,
          nurse: monthProfessionals[count].countWeek.nurse
        }
      };
      monthProfessionals[count] = weekProfessionals;
      count += 1;
    });
  }
  return monthProfessionals;
}
